import React, { memo, useCallback } from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import ReportOutlinedIcon from "@mui/icons-material/ReportOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { useNavigate } from "react-router-dom";

function NotFound({ type = "" }) {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "85vh",
      }}
    >
      <Container maxWidth="md">
        {type === "error" ? (
          <Grid
            container
            spacing={2}
            sx={{ flexDirection: "column", alignItems: "center" }}
          >
            <Grid item sx={{ display: "flex" }} xs={12} sm={12} md={12} lg={12}>
              <Grid
                sx={{ alignSelf: "center" }}
                item
                xs={7}
                sm={6}
                md={8}
                lg={8}
              >
                <Typography variant="h1">Oops</Typography>
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4}>
                <ErrorOutlineOutlinedIcon sx={{ fontSize: "120px" }} />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="h6">Something went wrong.</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button variant="contained" onClick={handleBack}>
                Back Home
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Grid
            container
            spacing={2}
            sx={{ flexDirection: "column", alignItems: "center" }}
          >
            <Grid item sx={{ display: "flex" }} xs={12} sm={12} md={12} lg={12}>
              <Grid
                sx={{ alignSelf: "center" }}
                item
                xs={7}
                sm={6}
                md={8}
                lg={8}
              >
                <Typography variant="h1">Sorry</Typography>
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4}>
                <ReportOutlinedIcon sx={{ fontSize: "120px" }} />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="h6">
                The page you requested cannot be found.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button variant="contained" onClick={handleBack}>
                Back Home
              </Button>
            </Grid>
          </Grid>
        )}
      </Container>
    </Box>
  );
}

export default memo(NotFound);
